import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, Form, Button, Message, Modal } from 'semantic-ui-react';
import { reduxForm } from 'redux-form/immutable';
import Input from '../../components/Form/Input';
import Dropdown from '../../components/Form/Dropdown';
import {
  required,
  requiredToBeTrue,
  email,
  minLength,
  maxLength,
} from "../../utils/validations";
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  loadCompanyInfo,
  check_signup,
  load,
  signup,
} from "../../redux/modules/auth";
import {
  getOrganizationInfoWithInviteToken,
} from '../../redux/modules/organization';
import './style.css';
import { Images } from '../../style';
import { getQueryParams } from '../../helpers/commonHelper';
import { TITLE } from '../../constants';
import { trackSignupCompletion } from "../../helpers/pixelHelper";

const minPasswordLength = minLength(3);
const minPhoneLength = minLength(8);
const maxPhoneLength = maxLength(20);
const maxLength50 = maxLength(50);

const CREATE_ACCOUNT = 'Create my account'
const FREE_TRIAL = 'Start your 7-day free trial'

const createAccountLabel = isFree => isFree ? FREE_TRIAL : CREATE_ACCOUNT

class Signup extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    handleSubmit: PropTypes.func,
    user: PropTypes.object,
    signupError: PropTypes.string
  };

  static defaultProps = {
    dispatch: null,
    handleSubmit: null
  };

  state = {
    username: '',
    firstName: '',
    lastName: '',
    isTermAndPolicyChecked: '',
    isRegFormStepSecOpen: false,
    shopifyToken: '',
    store: '',
    inviteToken: '',
    inviteEmail: false,
  };

  getInviteEmail = async inviteToken => {
    const { dispatch, initialize } = this.props;

    const { invite } = await dispatch(getOrganizationInfoWithInviteToken({ inviteToken, pending: true })) || {};

    if (invite !== undefined) {
      this.setState({ inviteEmail: !!invite.email });
      initialize({ username: invite.email });
    }
  }

  componentDidMount() {
    const { dispatch, match, location } = this.props;
    const { search } = location;

    const res = getQueryParams(search);
    if(res && res.shopifyToken) {
      this.setState({ shopifyToken: res.shopifyToken, store: res.store })
    }

    if(res && res.invite_token) {
      this.setState({ inviteToken: res.invite_token });

      this.getInviteEmail(res.invite_token);
    }

    const result = TITLE.filter(title => title === match.params.title);

    if(result.length === 0){
      return dispatch(push('/'));
    }

    if (match.params.title === 'free' && typeof window.fb_pixel_shopify_FreeSignup_PageView === 'function') {
      window.fb_pixel_shopify_FreeSignup_PageView();
    }

    if (typeof fb_pixel_code_BeforeRegistration !== "undefined") {
      window.fb_pixel_code_BeforeRegistration();
    }

    dispatch(loadCompanyInfo());
  }

  async componentDidUpdate() {
    const { user, signupInfo } = this.props;
    // we get signupInfo on signup() and the user on load()
    if (user && signupInfo) {
      await trackSignupCompletion(signupInfo.planId, !!signupInfo.isFromInvite);
      // V2-134 we don't want any other events getting triggered for the "shopify facebook pixel after the signup page.
      // After 'init' the pixel tracks events like button clicks/navigation automatically, so we have to force a page
      // refresh to get rid of the "shopify" facebook pixel on future pages.
      window.location.pathname = '/campaign';
    }
  }

  onSubmit = async (formData) => {
    const { dispatch, match } = this.props;
    const { shopifyToken, store, inviteToken } = this.state;
    let user = formData.toJS();
    if (inviteToken) {
      user.inviteToken = inviteToken;
    }

    if ((match.params.title === 'free') || (match.params.title === 'appsumo')) {
      user.planId = match.params.title;

      user.shopifyToken = shopifyToken;
      user.shopifyStore = store;
      await dispatch(signup(user));
      await dispatch(load());
      return;
    }

    const data = await dispatch(check_signup(user));
    if (data) {
      await dispatch(push('/plan'));
      localStorage.setItem('userObject', JSON.stringify(user));
    }
  }

  render() {
    const { loading, signupError, handleSubmit, match, budgetTypes } = this.props;
    const { shopifyToken, store, inviteEmail } = this.state;

    const budgetOptions = budgetTypes ? budgetTypes.map(({ id, label: text }) => ({ key: id, text, value: id })) : [];

    localStorage.setItem('title', match.params.title ? match.params.title : '');

    const isFreeSignUp = match.params.title === 'free';
    const isAppsumo = match.params.title === 'appsumo';

    return (
      <div className="height signup-bg">
        <Modal className="registrationform" size="tiny" open="true">
          {
            signupError && (
              <Message error content={signupError} />
            )
          }
          <Modal.Header className= "signupHeader primaryColor">
            <a href="/"><Image src={Images.logo} size='medium' centered/></a>
            { isAppsumo && <a href="/"><Image src={Images.appsumo} size='medium' centered/></a> }
            {createAccountLabel(isFreeSignUp)}
          </Modal.Header>
          <Modal.Content>
            <Form loading={loading} onSubmit={ handleSubmit(this.onSubmit) }>
              <Input
                name="firstName"
                data-testid="signupFirstName"
                icon="user"
                iconPosition="left"
                placeholder="First Name"
                type="text"
                size="large"
                validate={[required, maxLength50]}
              />
              <Input
                name="lastName"
                data-testid="signupLastName"
                icon="user"
                iconPosition="left"
                placeholder="Last Name"
                type="text"
                size="large"
                validate={[required, maxLength50]}
              />
              <Input
                name="jobTitle"
                data-testid="signupJobTitle"
                icon="user"
                iconPosition="left"
                placeholder="Job Title"
                type="text"
                size="large"
                validate={[required, maxLength50]}
              />
              <Input
                name="companyName"
                data-testid="signupCompanyName"
                icon="user"
                iconPosition="left"
                placeholder="Company Name"
                type="text"
                size="large"
                validate={[required, maxLength50]}
              />
              { inviteEmail
                ? <Input
                  name="username"
                  data-testid="signupInvitedUsername"
                  icon="user"
                  iconPosition="left"
                  type="text"
                  size="large"
                  disabled={true}
                />
                : <Input
                  name="username"
                  data-testid="signupUsername"
                  icon="user"
                  iconPosition="left"
                  placeholder="Company Email"
                  type="text"
                  size="large"
                  validate={[required, email, maxLength50]}
                  autoCorrect="off"
                  autoCapitalize="none"
                />
              }
              <Input
                name="password"
                data-testid="signupPassword"
                icon="key"
                iconPosition="left"
                placeholder="Password"
                type="password"
                autoComplete="new-password"
                size="large"
                validate={[required, minPasswordLength, maxLength50]}
              />
              {
                isFreeSignUp &&
                <Input
                  name="phoneNumber"
                  data-testid="signupPhoneNumber"
                  icon="phone"
                  iconPosition="left"
                  placeholder="Phone"
                  type="text"
                  size="large"
                  validate={[required, minPhoneLength, maxPhoneLength]}
                />
              }
              {
                isAppsumo &&
                <Input
                  name="appSumoCode"
                  data-testid="signupAppSumoCode"
                  placeholder="AppSumo code"
                  type="text"
                  size="large"
                  validate={[required]}
                />
              }
              <Dropdown
                name="budgetId"
                data-testid="signupBudgetOption"
                icon="caret down"
                placeholder="Approximate Marketing Budget"
                className="budgetDropdown"
                options={budgetOptions}
                validate={[required]}
              />
              <div className="conditions">
                <Input
                  name="isTermAndPolicyChecked"
                  data-testid="signupTermAndPolicy"
                  type="checkbox"
                  validate={[requiredToBeTrue]}
                />
                <label>I agree to the
                  <a href="https://videopeel.com/termsofuse/" target="_blank" className="hoverStyle"> Terms Of Use </a>
                  and
                  <a href="https://videopeel.com/privacypolicy/" target="_blank" className="hoverStyle"> Privacy Policy</a>
                </label>
              </div>
              <Button
                data-testid="signupSubmitButton"
                className="ui small fluid button front"
                type="submit"
                primary loading={loading}
              >
                NEXT
              </Button>
              {
                shopifyToken && isFreeSignUp &&
                <p className="signupHeader">Already have an account?
                  <a className="prevsignin" href={`/shopify/?shopifyToken=${shopifyToken}&store=${store}`}>
                    <span> Sign In</span>
                  </a>
                </p>
              }
            </Form>
          </Modal.Content>
          <div className="signupFooter">
            <p className= "signupHeader pb10">&copy;{new Date().getFullYear()} VideoPeel</p>
          </div>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.get('auth').get('user'),
    budgetTypes: state.get('auth').get('budgetTypes'),
    signupInfo: state.get('auth').get('signupInfo'),
    signupError: state.get('auth').get('signupError'),
    loading: state.get('auth').get('loading')
  }
}

export default connect(mapStateToProps)(reduxForm({
  form: 'signup'
})(Signup))



// WEBPACK FOOTER //
// ./src/containers/Signup/Signup.js